export const dataDefault = [{
    sort: 1,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}, {
    sort: 2,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}, {
    sort: 3,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}, {
    sort: 4,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}, {
    sort: 5,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}, {
    sort: 6,
    describe: "",
    level: "",
    result: "",
    loss: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/other/urgent/data.js